module.exports = __webpack_public_path__ + "img/inBan_smal_img01.5f2167d2.png";